export enum PersistDataEnum {
    USER_ID = 'bm_user_ID',
    USER = 'user',
    COLLABORATORS = 'collabs',
    TEMPORARY_TOKEN = "bm_tmp_token",
    ORGANISATION = 'organisation',
    IS_USER_ADMIN = 'is_user_admin',
    CATEGORY = 'category',
    PRODUCT = 'product',
    BASKET = 'basket',
    COLLABORATOR_BASKET = 'collab_basket',
    STASHED_BASKETS_KEY = 'stashedBaskets',
    CLIENTS = 'clients',
    SELECTED_CLIENT = 'selected_client',
    SALES = "sales",
    SELECTED_SALE = "selected_sale",
    CHAT_MESSAGES = "bm_byme_e",
}

export enum DashboardPersistDataEnum {
    // Dashboard related data
    DASHBOARD_YEAR_SALES = 'dashboard_year_sales',
    DASHBOARD_MONTH_SALES = 'dashboard_month_sales',
    DASHBOARD_WEEK_SALES = 'dashboard_week_sales',
    DASHBOARD_TODAY_SALES = 'dashboard_today_sales',
    DASHBOARD_TOP_PRODUCTS = 'dashboard_top_products',
    DASHBOARD_AVG_SALES_HOUR = 'dashboard_avg_sales_hour',
    DASHBOARD_AVG_SALES_DAY = 'dashboard_avg_sales_day',
    DASHBOARD_SELLER_PERFORMANCE = 'dashboard_seller_performance',
}
